import React, { useMemo, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Icon } from '../base/ui';
import { getLayoutMemberByType } from '../video-layout/functions';
import { DualMemeber } from './DualMemeber';
import { getDualLayoutCount } from './function';
export const DualMonitor = React.memo(() => {
    const dualItemRef = useRef(null);
    const remote = useSelector((state) => getLayoutMemberByType(state, 'remote') || [], shallowEqual);
    const count = getDualLayoutCount();
    const renderedItems = useMemo(() => Array.from({ length: count }).map((_, index) => remote[index] ? (React.createElement(DualMemeber, { key: remote[index], id: remote[index] })) : (React.createElement("div", { className: "dual-item", key: `no-user-${index}` },
        React.createElement("div", { className: "frame-987255 no_user" },
            React.createElement("div", { className: "icon-off-camera" },
                React.createElement(Icon, { icon: "icon-not-user", size: 65 })))))), [remote]);
    return React.createElement("div", { className: "dual-monitor", ref: dualItemRef }, renderedItems);
});
